import { PropsWithChildren } from 'react'
import classNames from 'classnames'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Motion from '@/components/base/Motion'

import { logoWallRevealAnimation } from './animations'
import { Section, WPImage, WPLink } from '@/types'

type LogoWallProps = Section &
  Partial<{
    collection: {
      image: WPImage
    }[]
    link: WPLink
  }>

const LogoCard = ({
  className,
  children
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={classNames(className)} data-motion-logo>
      <span className="aspect-h-1 aspect-w-1 block">
        <span className="flex h-full w-full items-center justify-center rounded-xxs bg-white p-gutter shadow-3xl">
          {children}
        </span>
      </span>
    </div>
  )
}

const LogoWall = ({ collection, link, ...props }: LogoWallProps) => {
  return (
    <Motion animation={logoWallRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-gutter">
              {collection?.map(({ image }, index) => (
                <LogoCard
                  key={`logo-${index}`}
                  className="col-span-1 md:col-span-2 lg:col-span-3"
                >
                  <Image
                    fit="contain"
                    size="full"
                    loading="lazy"
                    source={image}
                    alt={image?.alt}
                    className="h-full w-full object-contain"
                  />
                </LogoCard>
              ))}
            </Grid>
            {link ? (
              <Grid className="mt-2xl">
                <div className="col-span-2 md:col-span-6 lg:col-span-12">
                  <div data-motion-button>
                    <Button href={link?.url} link variant="contained">
                      {link?.title}
                    </Button>
                  </div>
                </div>
              </Grid>
            ) : null}
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default LogoWall
